import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Typography,
  Form,
  Input,
  Button,
  Checkbox,
  Spin,
  Row,
  Col,
  notification,
  theme,
  Modal,
  Alert,
  Card
} from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import UserApi from "../common/Apis/UserApi";
import pako from "pako";
import jwt_decode from "jwt-decode";
import RegisterForm from "../common/CommonUI/RegisterForm/RegisterForm";

const { Title } = Typography;

const Login = () => {
  const { useToken } = theme;
  const { token } = useToken();
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [RemeberLogin, Set_RemeberLogin] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [form] = Form.useForm();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [resetModalVisible, setResetModalVisible] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [passwordCriteria, setPasswordCriteria] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });

  // Check if user is already logged in
  useEffect(() => {
    const jwtToken = localStorage.getItem("UserjwtToken");
    if (jwtToken) {
      try {
        const compressedData = Uint8Array.from(
          atob(jwtToken),
          (c) => c.charCodeAt(0)
        );
        const decompressedData = pako.inflate(compressedData, { to: "string" });
        const decodedToken = jwt_decode(decompressedData);

        if (decodedToken && Date.now() / 1000 < decodedToken.exp) {

          // Force modal if temp password
          // if (decodedToken.tempLogin === true) {
          //   setResetModalVisible(true);
          //   return;
          // }

           notification.open({
                message: <span style={{ fontWeight: "bold" }}>Logged In</span>,
                description: "Welcome " + decodedToken.name,
                closeIcon: false,
                duration: 3,
                style: { backgroundColor: "#b3ffb3", color: "green" },
              });
              navigate("/dashboard");
              window.location.reload(true); 

          // UserApi.UserDetails()
          //   .then((response) => {
          //     localStorage.setItem("UserDetails", JSON.stringify(response?.payload));
          //     notification.open({
          //       message: <span style={{ fontWeight: "bold" }}>{response.resultStatus}</span>,
          //       description: "Welcome " + response?.payload?.email,
          //       closeIcon: false,
          //       duration: 3,
          //       style: { backgroundColor: "#b3ffb3", color: "green" },
          //     });
          //     navigate("/dashboard");
          //   })
          //   .catch((err) => console.log(err));

        } else {
          // Remove expired or invalid token
          localStorage.removeItem("UserjwtToken");
          localStorage.removeItem("decodedToken");
          localStorage.removeItem("UserDetails");
          // localStorage.removeItem("passwordResetDone");
          // localStorage.clear();
        }
      } catch (err) {
        console.log("Invalid token", err);
        localStorage.removeItem("UserjwtToken");
        localStorage.removeItem("decodedToken");
        localStorage.removeItem("UserDetails");
        // localStorage.removeItem("passwordResetDone");
        // localStorage.clear();

      }
    }
  }, [navigate]);

  // Handle login form submit
  const handleSubmit = (data) => {
    setLoadings(true);
    const formData = new FormData();
    formData.append("userName", data.userName);
    formData.append("password", data.password);

    UserApi.login(formData)
      .then((response) => {
        setLoadings(false);
        localStorage.setItem("UserjwtToken", response?.payload?.jwtToken);
        const compressedData = Uint8Array.from(
          atob(response?.payload?.jwtToken),
          (c) => c.charCodeAt(0)
        );
        const decompressedData = pako.inflate(compressedData, { to: "string" });
        const decodedToken = jwt_decode(decompressedData);
        localStorage.setItem("decodedToken", JSON.stringify(decodedToken));
        localStorage.setItem("RemeberLogin", RemeberLogin);

        if (decodedToken.tempLogin === true) {
          setResetModalVisible(true);
          return;
        }
        
        notification.open({
              message: <span style={{ fontWeight: "bold" }}>Logged In</span>,
              description: "Welcome " + decodedToken.name,
              closeIcon: false,
              duration: 3,
              style: { backgroundColor: "#b3ffb3", color: "green" },
            });
            setTimeout(() => {
              navigate("/dashboard");
              window.location.reload(true);
            }, 3000);


        // UserApi.UserDetails()
        //   .then((response) => {
        //     localStorage.setItem("UserDetails", JSON.stringify(response?.payload));
        //     notification.open({
        //       message: <span style={{ fontWeight: "bold" }}>{response.resultStatus}</span>,
        //       description: "Welcome " + response?.payload?.email,
        //       closeIcon: false,
        //       duration: 3,
        //       style: { backgroundColor: "#b3ffb3", color: "green" },
        //     });
        //     setTimeout(() => navigate("/dashboard"), 3000);
        //   })
        //   .catch((err) => console.log(err));

      })
      .catch((err) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>,
          description: err.apiError.message,
          closeIcon: false,
          duration: 3,
          style: { backgroundColor: "#ffb3b3", color: "red" },
        });
        console.log(err);
      });
  };

  // Handle reset password
  const handleResetPassword = (values) => {
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    setResetLoading(true);
    setApiError(null);
    const resetData = {
      email: decodedToken.sub,
      oldPassword: values.currentPassword,
      newPassword: values.newPassword,
    };

    UserApi.changePassword(resetData)
      .then(() => {
        setResetLoading(false);
        setResetModalVisible(false);
        // localStorage.setItem("passwordResetDone", "true");
        // localStorage.removeItem("UserjwtToken");
        // localStorage.removeItem("decodedToken");
        // localStorage.removeItem("UserDetails");
        localStorage.clear();
        window.location.reload();
        notification.success({
          message: "Password Reset Successful",
          description: "Please login again with your new password.",
          style: { backgroundColor: "#b3ffb3", color: "green" },
        });
      })
      .catch((err) => {
        setResetLoading(false);
        setApiError(err.apiError?.message || "Password reset failed");
      });
  };

  // Handle changes in reset password form
  const handleResetFormChange = () => {
    const values = form.getFieldsValue();
    const hasEmptyField =
      !values.currentPassword || !values.newPassword || !values.confirmPassword;
    const passwordsMatch = values.newPassword === values.confirmPassword;
    const allCriteriaMet = Object.values(passwordCriteria).every(Boolean);
    setIsButtonDisabled(hasEmptyField || !passwordsMatch || !allCriteriaMet);
  };

  // Update password criteria dynamically
  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setPasswordCriteria({
      length: value.length >= 8,
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /[0-9]/.test(value),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(value),
    });
    handleResetFormChange();
  };

  return (
    <>
      <div className="container container-body form-container">
        <div className="row justify-content-center">
          <div className="col-xl-9 col-lg-9 col-md-11 content-border my-2 IpadView">
            <Row gutter={24}>
              <RegisterForm />
              <Col lg={12} md={24} className="py-4" style={{ boxShadow: "8px 8px 16px -4px rgba(0, 0, 0, 0.1)" }}>
                <Form
                  name="nest-messages"
                  layout="vertical"
                  onFinish={handleSubmit}
                  className="p-5 px-4 Register-form"
                >
                  <div className="d-flex justify-content-center pb-4">
                    <img src="/assest/Images/Logo/logo.png" className="logo-png" />
                  </div>

                  <Title style={{ textAlign: "center", color: "black", marginBottom: 30 }} level={4} className="Primary-Font">
                    Sign in to your account
                  </Title>

                  <Form.Item
                    name="userName"
                    className="text-lable"
                    rules={[{ required: true, message: "Your username must include only alphabet characters." }]}
                  >
                    <Input type="text" className="form-control control-input" placeholder="Email / Username" />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    className="text-lable"
                    rules={[{ required: true, message: "Your password must include only alphabet characters." }]}
                  >
                    <Input.Password
                      placeholder="Password"
                      className="control-input mb-2"
                      visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
                    />
                  </Form.Item>

                  <Button type="primary" htmlType="submit" className=" mt-2 w-100" disabled={loadings} style={{ background: token.colorPrimary , padding: '10px 0' }}>
                    Continue with email{loadings && <Spin className="px-2" />}
                  </Button>

                  <p style={{ textAlign: "center", marginTop: "15px" }}>
                    OR
                  </p>

                  <Button type="primary" className=" mt-2 w-100" disabled={loadings} style={{ background: token.colorPrimary , padding: '10px 0' }} onClick={() => navigate('/code-login')}>
                    Login with code
                  </Button>

                  <div className="pt-5 remember-p Login">
                    <Form.Item name="remember" valuePropName="checked" className="text-lable" checked={RemeberLogin === false} onChange={() => Set_RemeberLogin(!RemeberLogin)}>
                      <Checkbox>Remember Me</Checkbox>
                    </Form.Item>
                    <span style={{ float: "right" }}>
                      <Link to={"/forgot-password"} className="content-link">Forgot Password?</Link>
                    </span>
                  </div>
                  <p className="content">
                    Contact us <Link to="mailto:Info@ivaconnect.ie" className="content-link">Info@ivaconnect.ie</Link>
                  </p>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Reset Password Modal */}
      <Modal title="Reset Your Password" open={resetModalVisible} onCancel={() => setResetModalVisible(false)} footer={false} maskClosable={false} destroyOnClose>
        <p style={{ marginBottom: "16px", color: "#555" }}>
          You are currently using a temporary password provided by the admin.
          For security reasons, please change your password to continue accessing the system.
        </p>

        <Form layout="vertical" form={form} onFinish={handleResetPassword} requiredMark={true} onValuesChange={handleResetFormChange}>
          <Form.Item
            name="currentPassword"
            label={<span>Current Password <span style={{ color: "red" }}>*</span></span>}
            rules={[{ required: true, message: "Please enter your current password" }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label={<span>New Password <span style={{ color: "red" }}>*</span></span>}
            rules={[{ required: true, message: "Please enter a new password" }]}
          >
            <Input.Password onChange={handleNewPasswordChange} />
          </Form.Item>

          {/* Password Criteria */}
          <Card
            size="small"
            title="Password must contain:"
            style={{ marginBottom: "16px", borderRadius: 8, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: 14 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", color: passwordCriteria.length ? "green" : "red" }}>
                {passwordCriteria.length ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                At least 8 characters
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", color: passwordCriteria.uppercase ? "green" : "red" }}>
                {passwordCriteria.uppercase ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                At least one uppercase letter
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", color: passwordCriteria.lowercase ? "green" : "red" }}>
                {passwordCriteria.lowercase ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                At least one lowercase letter
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", color: passwordCriteria.number ? "green" : "red" }}>
                {passwordCriteria.number ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                At least one number
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", color: passwordCriteria.special ? "green" : "red" }}>
                {passwordCriteria.special ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                At least one special character (!@#$%^&* etc.)
              </div>
            </div>
          </Card>

          <Form.Item
            name="confirmPassword"
            label={<span>Confirm Password <span style={{ color: "red" }}>*</span></span>}
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) return Promise.resolve();
                  return Promise.reject(new Error("The two passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          {apiError && <Alert message={apiError} type="error" showIcon className="mb-3" />}

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={resetLoading} block size="middle" style={{ padding: "5px 0" }} disabled={isButtonDisabled}>
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Login;
